const fetchOrderLoading = state => state.orderDetails.loading;
const customerInfo = state => state.orderDetails.customerInfo;
const orderItems = state => state.orderDetails.order.items.filter(item => item.policy.status !== 'Voided');
const orderInfo = state => state.orderDetails.order;
const clientSettings = state => state.orderDetails.clientSettings;
const fetchOrderErrorMessage = state => state.orderDetails.errorMessage;

const requiresPayment = state => state.addressDetails.requiresPayment;
const addressData = state => state.addressDetails.data;
const addressCustomer = state => state.addressDetails.customer;
const addressItems = state => state.addressDetails.items;
const addressPolicies = state => state.addressDetails.policies.filter(policy => policy.status !== 'Voided');
const addressOrderNumber = state => state.addressDetails.orderNumber;
const addressSymbol = state => state.addressDetails.symbol;
const addressLoading = state => state.addressDetails.loading;
const addressErrorMessage = state => state.addressDetails.errorMessage;
const addressSuccessMessage = state => state.addressDetails.successMessage;

const rechargeLoading = state => state.recharge.loading;
const rechargeErrorMessage = state => state.recharge.errorMessage;
const rechargeConfirmation = state => state.recharge.id;

const openEndedOrderData = state => state.openEndedDetails.data;
const openEndedOrderLoading = state => state.openEndedDetails.loading;

export default {
  fetchOrderLoading,
  customerInfo,
  orderItems,
  orderInfo,
  requiresPayment,
  clientSettings,
  fetchOrderErrorMessage,
  addressData,
  addressCustomer,
  addressItems,
  addressPolicies,
  addressOrderNumber,
  addressSymbol,
  addressLoading,
  addressErrorMessage,
  addressSuccessMessage,
  rechargeLoading,
  rechargeErrorMessage,
  rechargeConfirmation,
  openEndedOrderData,
  openEndedOrderLoading,
};
